import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SelectsDetailPageRoutingModule } from './selects-detail-routing.module';

import { SelectsDetailPage } from './selects-detail.page';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, SelectsDetailPageRoutingModule],
  declarations: [SelectsDetailPage]
})
export class SelectsDetailPageModule {}
